module.exports = __webpack_public_path__ + "static/img/video.528f5fbc.png";